import { render, staticRenderFns } from "./CandidateFitCard.vue?vue&type=template&id=f544772a&scoped=true"
import script from "./CandidateFitCard.vue?vue&type=script&lang=ts"
export * from "./CandidateFitCard.vue?vue&type=script&lang=ts"
import style0 from "./CandidateFitCard.vue?vue&type=style&index=0&id=f544772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f544772a",
  null
  
)

export default component.exports